import React from 'react';
import { string, func, shape, arrayOf, object } from 'prop-types';
import { Container } from 'react-bootstrap';

import Breadcrumbs from '../Demos/Breadcrumbs';

import PageHeader from './PageHeader';

import './page.scss';

function Page({ title, description, component: Component, rootPath, subPath }) {
  return (
    <div className="page-container">
      <Breadcrumbs rootPath={rootPath} subPath={subPath} />
      <Container className="page-content">
        {title && <PageHeader title={title} />}
        {description && <p>{description}</p>}
        <Component />
      </Container>
    </div>
  );
}
Page.propTypes = {
  title: string,
  description: string,
  component: func,
  rootPath: shape({
    name: string,
    uri: string,
  }),
  subPath: arrayOf(object),
};

export default Page;
